import { useEffect } from 'react'
import { BiometryStartModal } from '../components/BiometryStartModal'
import { useBiometryStore } from '../store/biometry-store'

export const BiometryManager = () => {
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search)

    if (urlSearchParams.has('fromBiometry')) {
      useBiometryStore.setState({
        biometryValidated: true,
        callbackRoute: null,
      })
    }
  }, [])

  return <BiometryStartModal />
}
